import apiConfig from '../../api/api-config';
import { useAuth } from '../../context/contextAuth';
import { useProfile } from '../../context/contextProfile';
import { useDesign } from '../../context/contextDesign';
import { useThemeMode } from '../../context/contextTheme';
const api_base_url_2 = apiConfig.api_base_url_2;

const SidebarDoc = () => {
  const { theme } = useThemeMode();
  const { upgradePlan } = useAuth();
  const { extendedVal } = useDesign();
  const { sidebarExtended } = useProfile();

  return (
    <div
      className="position-absolute p-1 z-1"
      style={{
        margin: '0.26rem',
        borderRadius: '20px',
        border: `1px solid ${theme.border}`,
        backgroundColor: theme.background2,
        bottom: sidebarExtended ? (!upgradePlan ? 3 : 6) : -400,
        width: sidebarExtended ? extendedVal - 10 : extendedVal,
        transition: sidebarExtended ? 'all 0.7s' : 'all 0.0s',
      }}>
      <div className="text-center py-1">
        <a href={`${api_base_url_2}/save-doc`} target="_blank" rel="noopener noreferrer"
          style={{ fontSize: '13px', fontWeight: 500, color: theme.textColor }}>
          Documentation
        </a>
      </div>
    </div>
  )
};

export default SidebarDoc;